<mat-form-field class="flex-grow">
  <mat-label>{{labelName}}</mat-label>
  <mat-select [formControl]="trackerFormControl">
    <mat-option [value]="null"> -- </mat-option>
    @for (option of options; track option) {
      <mat-option [value]="option.value">{{ option.name }}</mat-option>
    }
  </mat-select>
  @if (hasError) {
    <mat-error>{{errorMessage}}</mat-error>
  }
</mat-form-field>